<template>
  <MenuItem :data="diagnosisList" header="Battery"/>
</template>
<script>
import MenuItem from './components/MenuItem';
import { modelOpenRouter } from '@/mixins/model-open';
export default {
  name: 'DiagnosisBattery',
  mixins: [modelOpenRouter],
  components: {
    MenuItem
  },
  data () {
    return {
      diagnosisList: [
        {
          id: 'diagnosisBattery',
          img: 'item_part_battery.png',
          item: 'Battery',
          path: ''
        },
        {
          id: 'diagnosisBack',
          img: 'item_back.png',
          item: 'Back',
          path: '/service-tools/diagnosis'
        },
        {
          id: 'diagnosisFinishAndCreateReport',
          img: 'item_confirm.png',
          item: 'Finish and Create Report',
          path: 'confirm'
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
</style>
